

















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {}
})
export default class Label extends Vue {
    @Prop({
        type: String,
        required: true
    })
    title!: string;
    @Prop({
        type: Number,
        default: 12
    })
    spacing!: number;
    @Prop({
        type: Number,
        default: 0
    })
    height!: number;
    styleObject: {
        height?: string;
        marginRight?: string;
    } = {};
    onClick(ev) {
        this.$emit('click',ev);
    }
    mounted() {
        this.styleObject = {
            marginRight: `${this.spacing}px`
        };
        if (this.height) {
            this.styleObject.height = `${this.height}px`;
        }
    }
}
